export const ALLOW_RENDER = 'ALLOW_RENDER';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/allowRender.js